import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { DialogData } from '../../../schedule/components/select-games-dialog/select-games-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { ReportDetailsComponent } from "../../screens/report-details/report-details.component";
import { ReportOverallGradesNewComponent } from '../report-overall-grades-new/report-overall-grades-new.component';
import { Router, RouterModule } from '@angular/router';


@Component({
  selector: 'app-report-details-dialog',
  imports: [MatDialogModule, MatButtonModule, ReportDetailsComponent, RouterModule],
  templateUrl: './report-details-dialog.component.html',
  styleUrl: './report-details-dialog.component.css'
})
export class ReportDetailsDialogComponent {
    readonly dialogRef = inject(MatDialogRef<ReportDetailsDialogComponent>);
    readonly data = inject(MAT_DIALOG_DATA);

}
